import gql from 'graphql-tag';

export const filteredSubscriptions = gql`
  query FilteredSubscriptions($subscriptionsFilter: subscriptionsFilterInput) {
    filteredSubscriptions(filter: $subscriptionsFilter) {
      _id
      email
      name
      phone
      textSubscription
      emailSubscription
      emailOptIn
      source
      dateAdded
      dispensaryId
      dispensaryName
      numOrders
      orderTotal
      createdAt
      createdBy
      userId
      dispensary {
        name
        location {
          city
          state
        }
        logoImage
      }
    }
  }
`;
